<template>
  <span style="margin-right: 10px">
    <!-- 未接听电话，显示【サポート開始】 -->
    <el-button plain v-if="!$store.state.stt.isMicOn" 
      :key="'start-support'"
      size="small" 
      :type ="buttonType" 
      @click="$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE' ? handleAnswerButtonClick() : turnMicStart() "
      :disabled ="callButtonDisabled"
    >
      {{this.$store.state.sysInit.turnMicStart_title}}
    </el-button>
    <!-- <el-button
      ref="turnMicStart"
      size="small"
      :type="this.$store.state.sysInit.ws_start_button"
      plain
      @click="
        $store.state.sysInit.talkStatus === 'end'
          ? turnMicEnd()
          : turnMicStart()
      "
      v-if="!$store.state.stt.isMicOn && !showAnswerCall"
      :disabled="$store.state.sysInit.modeFlag"
    > -->
      <!-- <icon name="phone"></icon> -->
      <!-- {{ this.$store.state.sysInit.turnMicStart_title }} -->
      <!-- {{this.$store.state.sysInit.ws_mode==="NEXMO_ASTERISK_PBX_MODE"? this.$store.state.sysInit.turnMicStart_title : this.$store.state.sysInit.html_const.cons_205_start}}
             -->

      <!-- 通話開始 -->
    <!-- </el-button> -->
    <!-- 外线电话接听后，显示【サポート終了】，按下可以挂断电话 -->
    <el-button
      :key="'stop-support'"
      v-if="showEndCall"
      size="small"
      plain
      type="primary"
      @click="turnMicEnd"
    >
      {{ this.$store.state.sysInit.turnMicStart_title }}
    </el-button>
    <!-- 外线电话接听后挂掉了 or 拨打/接听了内线电话，前者显示为【起票】，后者显示为 -->
    <!-- <el-button
      :key="'create-ticket'"
      size="small"
      :type="this.$store.state.sysInit.ws_start_button"
      plain
      v-if="$store.state.stt.isMicOn && !showEndCall"
      @click="turnMicEnd"
      :disabled="$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE' ? isButtonDisabled : $store.state.sysInit.modeFlag"
    > -->
      <!-- 暂时注释掉，以后需要通过hangup图标表示某种状态时再使用 -->
      <!-- <icon name="phone-hangup"></icon> -->
      <!-- {{ this.$store.state.sysInit.turnMicStart_title }} -->
      <!-- 通話終了  -->
    <!-- </el-button> -->
  </span>
</template>

<script>
import api from "@/api";
import moment from "moment";
export default {
  data() {
    return {
      isButtonDisabled: true,
    }
  },
  computed:{
    callButtonDisabled(){
      if(this.$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE'){
        return this.$store.state.phone.selectedLine === '' || this.$store.state.phone.inCallList.length > 0 || !this.checkIfSupportCall(this.$store.state.phone.selectedLine) || (this.$store.state.phone.waitingList.filter(item => item.telnum == this.$store.state.phone.selectedLine).length == 0)
        //return !this.checkIfSupportCall(this.$store.state.phone.selectedLine) 
      }else{
        return this.$store.state.sysInit.modeFlag
      }
    },
    buttonType(){
      return this.$store.state.sysInit.ws_start_button
    },
    showEndCall(){
      return this.$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE' && this.$store.state.sysInit.talkStatus == "start" && this.checkIfSupportCall(this.$store.state.phone.currentCallerNum)
    },
  },
  methods: {
    turnMicStart() {
      this.emptyTextStatus = "start";
      if (
        this.$store.state.sysInit.talkStatus === "start" &&
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
      ) {
        // this.dialogTableVisible = true;
        this.$store.state.store_sv.phone_sv_help_status = 'iscalling'
        this.$store.dispatch(
          "sysInit/changerTurnMicStartTitle",
          this.$store.state.sysInit.ws_mode
        );
        // this.$refs.turnMicStart.$el.click();
        this.$store.state.stt.sttStartTime = moment().format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$store.state.stt.startTime = moment(
          this.$store.state.stt.sttStartTime
        ).format("HH:mm:ss");

        this.$store.dispatch("stt/turnMicStart");
        // this.$store.commit("sysInit/changeNavigationText", "AIアシスタントが起動されました");
        this.$store.commit(
          "sysInit/changeNavigationText",
          this.$store.state.sysInit.html_const.cons_237_footer_start_button
        );

        this.$store.state.stt.stopStatus = "danger";
        this.$store.state.stt.scrollStatus = "danger";
        this.$store.state.stt.isScroll = true;
        this.$store.state.stt.isMouse = true;
        // 通話開始ボタンが押下されたら、ステータスを通話中と設定
        this.$store.state.sysInit.status = "BUSY";
        let modeFlag = true;
        this.$store.commit("sysInit/changeSysConfig", { modeFlag, modeFlag });
      } else {
        // this.end_btn_control();
        // this.dialogTableVisible = true;

        this.$store.state.stt.sttStartTime = moment().tz("Asia/Tokyo").format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$store.state.stt.startTime = moment(
          this.$store.state.stt.sttStartTime
        ).format("HH:mm:ss");

        this.$store.state.stt.isDisabl = false;
        // this.btn_type = "primary";
        this.$store.dispatch("stt/turnMicStart");
        this.$store.dispatch(
          "sysInit/changerTurnMicStartTitle",
          this.$store.state.sysInit.ws_mode
        );
        // this.$store.commit("sysInit/changeNavigationText", "AIアシスタントが起動されました");
        this.$store.commit(
          "sysInit/changeNavigationText",
          this.$store.state.sysInit.html_const.cons_237_footer_start_button
        );

        this.$store.state.stt.stopStatus = "danger";
        this.$store.state.stt.scrollStatus = "danger";
        this.$store.state.stt.isScroll = true;
        this.$store.state.stt.isMouse = true;
        // 通話開始ボタンが押下されたら、ステータスを通話中と設定
        this.$store.state.sysInit.status = "BUSY";
      }

        this.$store.state.sysInit.piDiaLogVisible = false;
      
    },
    turnMicEnd() {
      if (this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
        // ダイアログだけ表示し、実際の通話終了処理はダイアログのOKボタン押下後に実行する
        this.$store.state.stt.dialogVisible = true;
      } else {
        this.$store.state.stt.dialogVisible = true;
      }
    },
    answerAudioCall(){
      console.log('this.$store.state.phone.selectedLine....',this.$store.state.phone.selectedLine)
      this.$SIP.AnswerAudioCall(this.$store.state.phone.selectedLine)
      this.$store.state.sysInit.piDiaLogVisible = false;
    },
    checkIfSupportCall(line){
      return line.length > 5 || (line.length == 5 && line[0] ==='9') || this.$store.state.phone.Tnumber
    },
    endAudioCall(){
      this.$SIP.ToggleDoNoDisturb(true);
      this.$SIP.endSession(this.$store.state.phone.currentCallerNum);
    },
    handleAnswerButtonClick() {
      if (this.$store.state.sysInit.role == 'supervisor') {
        // 如果当前登录用户的角色为SV
        console.log('当前登录用户的角色为SV，需要判断是否在UC3上面开启了电话监听');
        let params = {
          telNum: this.$store.state.sysInit.tel_num,
        };
        api.searchMonitoringTelNum(params).then(res => {
          if (res.data.data) {
            if (res.data.data.monitoringTelNum) {
              // 如果当前登录用户在UC3上面正在监听某通电话
              console.log(`当前登录用户${this.$store.state.sysInit.tel_num}正在UC3上面监听${res.data.data.monitoringTelNum}`);
              // 1. 记录下点击的数据行的电话号码
              this.$store.commit('phone/updateLineNumber', this.$store.state.phone.selectedLine);
              // 2. 记录下触发器为CTI的作业开始按钮
              this.$store.commit('phone/updateStopMonitoringTrigger', 'CTI_CALL_START_BTN');
              // 3. 确认是否要停止UC3上面的电话监听
              this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: true});
            } else {
              // 如果当前登录用户在UC3上面没有监听任何电话
              console.log(`当前登录用户${this.$store.state.sysInit.tel_num}未在UC3上面开启监听`);
              // 在UC2上面开始电话接听
              this.answerAudioCall(this.$store.state.phone.selectedLine);
            }
          } else {
            // 展示错误信息
            this.$message.error('System error');
          }
        })
      } else {
        // 如果当前登录用户的角色不是SV
        console.log('当前登录用户的角色不是SV，在UC2上面直接开始电话接听');
        this.answerAudioCall(this.$store.state.phone.selectedLine);
      }
    },
  },
  watch: {
    "$store.state.phone.stopMonitoring": function(stopMonitoring) {
      // 确定要停止UC3上面的电话监听
      if (stopMonitoring) {
        // 是通过CTI的作业开始按钮触发的停止监听事件
        if (this.$store.state.phone.stopMonitoringTrigger == 'CTI_CALL_START_BTN') {
          let lineNumber = this.$store.state.phone.lineNumber;
          // 把确认是否要停止UC3上面的电话监听的结果重置为初始状态false
          this.$store.state.phone.stopMonitoring = false;
          // 把点击的数据行的来电号码重置为初始状态空字符串
          this.$store.state.phone.lineNumber = '';
          let params = {
            userId: this.$store.state.sysInit.user_id,
            telNum: this.$store.state.sysInit.tel_num,
          }
          api.stopMonitoring(params).then(res => {
            if (res.data.data) {
              // 要求在UC3上面停止电话监听的Message发送成功
              // 开始在UC2上面的电话接听
              this.answerAudioCall(lineNumber);
            } else {
              // 展示错误信息
              this.$message.error('System error');
            }
          });
        }
      }
    },
    "$store.state.phone.callList": function(callList) {
      let nonWaitingCallList = callList.filter(item => !item.isWaiting);
      if (nonWaitingCallList.length > 1) {
        if (this.isButtonDisabled == false) {
          this.isButtonDisabled = true;
        }
      } else {
        if (this.isButtonDisabled == true) {
          this.isButtonDisabled = false;
        }
      }
    }
  },
};
</script>
<style>
</style>